import http from "infra/http";
import { useQuery } from "react-query";
import {
  TransferenciaItem,
  TransferenciaListagemRequestParams,
} from "../typings";
import { PaginateResult } from "core/resources/types/shared";

function useTransferencias(params: TransferenciaListagemRequestParams) {
  return useQuery([`/v1/transferencia`, params], async () => {
    const { data } = await http.get<PaginateResult<TransferenciaItem>>(
      `/v1/transferencia`,
      {
        params,
      }
    );

    return data;
  });
}

export default useTransferencias;
